var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _vm.navBar
        ? _c("van-nav-bar", {
            attrs: {
              "left-arrow": "",
              fixed: "",
              placeholder: true,
              "safe-area-inset-top": ""
            },
            on: { "click-left": _vm.onClickLeft },
            scopedSlots: _vm._u(
              [
                {
                  key: "right",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3743218793
            )
          })
        : _vm._e(),
      _vm.show
        ? _c("div", [
            _c("div", { staticClass: "newsTitle" }, [
              _c("h1", [_vm._v(_vm._s(_vm.title ? _vm.title : ""))]),
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "leftText van-ellipsis" }, [
                  _c("span", [_vm._v(_vm._s(_vm.subtitle ? _vm.subtitle : ""))])
                ]),
                _c("div", { staticClass: "rightText" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("formatDate_")(_vm.newTime)))
                  ])
                ])
              ])
            ]),
            !_vm.content ? _c("div") : _vm._e(),
            _vm.content
              ? _c("div", {
                  staticClass: "contentTxt",
                  domProps: { innerHTML: _vm._s(_vm.content) }
                })
              : _vm._e()
          ])
        : _vm._e(),
      !_vm.show
        ? _c(
            "div",
            [
              _c("van-empty", {
                staticClass: "custom-image",
                attrs: {
                  image: require("@/assets/images/pic_no information@2x.png"),
                  description: "暂无数据!"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "newsBtm" }, [
        _c("div", { staticClass: "statementBox" }, [
          _c("div", { staticClass: "statement" }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c("van-icon", { attrs: { name: "bulb-o" } }),
                _vm._v(" "),
                _c("h5", [_vm._v("免责声明")])
              ],
              1
            ),
            _c("p", [
              _vm._v(
                " 数据来源于网络，本平台尊重提倡保护知识产权，本文所引述机构或个人的观点、言论、数据及其他信息仅作参考和资讯传播之目的，不代表本平台赞同其观点或证实其描述。如对该系统链接服务存在异议，或发现违法及不良信息，请致电4001-886-722我们将及时处理。 "
              )
            ])
          ])
        ]),
        _c("img", {
          attrs: {
            src: require("@/assets/images/pic_news_bottom@2x.png"),
            alt: ""
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }